import { createFileRoute, redirect } from '@tanstack/react-router';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Finance/Ledgers/GuestLedger')({
    loader: ({ params }) => {
        throw redirect({ to: '/$currentEnterpriseId/Finance/Ledgers/Guest', params });
    },
    staticData: {
        owner: MewsTeam.Accounting,
        type: RouteType.Redirect,
    },
});
